"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require("./base.js");

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    /********
    	description：获取地址栏参数
    	paramter：
    		name:【必需】获取URL的参数名
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    getQueryString: function getQueryString(name) {
        //search和hash的区别，如果URL中“？”之前有一个“#” 那么使用window.location.search得到的就是空（“”）
        var urlParams = decodeURIComponent(window.location.search.split("?")[1] || window.location.hash.split("?")[1]);
        if (urlParams) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = urlParams.match(reg);
            if (r != null) {
                return r[2];
            } else {
                return null;
            }
        }
    },

    /********
        description：根据旗舰店规则自动补全
        paramter：
            addressStr:【必需】需补全的地址
        version:1.0.0
        data:2021/11/05
        changeContent:基础版(cuishuai)
    ********/
    autoFlagship: function autoFlagship(addressStr) {
        var path = this.getPathRoot();
        if (path) {
            var arr = addressStr.split("/");
            if (arr[0] == "http:" || arr[0] == "https:") {
                arr[0] = arr[0] + "//";
            }
            if (arr[3]) {
                arr[3] = "/" + arr[3];
            }
            arr.splice(3, 0, path);
            addressStr = arr.join("");
        }
        return addressStr;
    },

    /********
        description：计算当前地址是否为旗舰店地址
        paramter：
        version:1.0.0
        data:2021/11/05
        changeContent:基础版(cuishuai)
    ********/
    getPathRoot: function getPathRoot() {
        var pathRoot = location.pathname.split("/");
        return pathRoot[1] == "shop" ? "/" + (pathRoot[1] || "") + "/" + (pathRoot[2] || "") : "";
    },

    //下载文件
    getBlob: function getBlob(url) {
        return new Promise(function (resolve) {
            var xhr = new XMLHttpRequest();

            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
                if (xhr.status === 200) {
                    resolve(xhr.response);
                }
            };

            xhr.send();
        });
    },
    saveAs: function saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
        }
        //for ie
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var link = document.createElement('a');
            var body = document.querySelector('body');

            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            // fix Firefox
            link.style.display = 'none';
            body.appendChild(link);

            link.click();
            body.removeChild(link);

            window.URL.revokeObjectURL(link.href);
        }
    },
    download: function download(url, filename) {
        var _this = this;

        this.getBlob(url).then(function (blob) {
            _this.saveAs(blob, filename);
        });
    },

    /********
    description：IE9路由地址不修改 跳转不生效问题
    paramter：
    version:1.0.0
    data:2020/10/13
    changeContent:基础版(chenkailei)
    ********/
    RELOAD: function RELOAD() {
        var browserObj = _base2.default.getBrowser();
        if (browserObj.name == "ie" && browserObj.version == "9.0") {
            location.reload();
        }
    }
};